import { AbstractCommand } from 'src/models/command';

class BatchDelayTasksOneDayCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_BatchDelayTasksOneDay';

	public constructor(aggregateIds: string[]) {
		super();

		if (!Array.isArray(aggregateIds)) {
			throw new Error('aggregateIds must be an array');
		}

		if (aggregateIds.length === 0) {
			throw new Error('aggregateIds array cannot be empty');
		}

		if (!aggregateIds.every((id) => typeof id === 'string' && id.trim().length > 0)) {
			throw new Error('All aggregateIds must be non-empty strings');
		}

		this.parameters = {
			aggregateIds: aggregateIds,
			batchSize: aggregateIds.length,
		};
	}
}

export { BatchDelayTasksOneDayCommand };
